export default __webpack_public_path__ + "static/media/109.4a9b1710.jpg";